const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="1.8"
      d="M12 0a1.2 1.2 0 0 0-1.2 1.2v14.401A1.2 1.2 0 0 0 12 16.8a1.2 1.2 0 0 0 1.2-1.199v-14.4A1.2 1.2 0 0 0 12 0"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="1.8"
      d="M1.2 14.4A1.2 1.2 0 0 0 0 15.601V20.4C0 22.374 1.626 24 3.6 24h16.8c1.974 0 3.6-1.626 3.6-3.6V15.6a1.2 1.2 0 0 0-1.199-1.2 1.2 1.2 0 0 0-1.2 1.2V20.4c0 .677-.524 1.2-1.201 1.2H3.6c-.677 0-1.2-.523-1.2-1.2V15.6a1.2 1.2 0 0 0-1.2-1.2"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="1.8"
      d="M6 8.4a1.2 1.2 0 0 0-.848.352 1.2 1.2 0 0 0 0 1.697l6 6a1.2 1.2 0 0 0 1.696 0l6.001-6a1.2 1.2 0 0 0 0-1.697 1.2 1.2 0 0 0-1.698 0L12 13.905 6.85 8.752a1.2 1.2 0 0 0-.85-.351"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;
